import { render, staticRenderFns } from "./TranzilaTerminalPassword.vue?vue&type=template&id=117b1063&"
import script from "./TranzilaTerminalPassword.vue?vue&type=script&lang=ts&"
export * from "./TranzilaTerminalPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports